import { render, staticRenderFns } from "./security-details-modal.vue?vue&type=template&id=08ddc15f&scoped=true&"
import script from "./security-details-modal.vue?vue&type=script&lang=js&"
export * from "./security-details-modal.vue?vue&type=script&lang=js&"
import style0 from "./security-details-modal.vue?vue&type=style&index=0&id=08ddc15f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddc15f",
  null
  
)

export default component.exports